import { render, staticRenderFns } from "./BankTransferSuccess.vue?vue&type=template&id=63da0874"
import script from "./BankTransferSuccess.vue?vue&type=script&lang=js"
export * from "./BankTransferSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports